import { combineReducers } from 'redux';

import authSlice from './slice/auth';
import toastSlice from './slice/toast';

export const rootReducer = combineReducers({
    auth: authSlice.reducer,
    toast: toastSlice.reducer,
});
